import React, { useCallback, useEffect, useState } from "react";
import {
  DgaButton,
  DgaCard,
  DgaCarousel,
  DgaCarouselItem,
  DgaLoading,
} from "platformscode-new-react";
import { EServiceCardHome } from "../../../components/shared/EServiceCardHome";
import useEmblaCarousel from "embla-carousel-react";
import {
  useDotButton,
  DotButton,
} from "../../../components/shared/emblaCarousel/EmblaCarouselDotButton";
import {
  DgaCircleSkeleton,
  DgaLineSkeleton,
  DgaRectangleSkeleton,
  DgaSquareSkeleton,
} from "platformscode-new-react";

import {
  NextButton,
  PrevButton,
  usePrevNextButtons,
} from "../../../components/shared/emblaCarousel/EmblaCarouselArrowButtons";

import { useNavigate } from "react-router-dom";

import CarouselSlider from "../../../components/shared/CarouselSlider";
import { getHomeServices } from '../../../services/api';
 

function ServicesSection() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  // 1. تعريف خيارات Carousel أولاً
  const [options] = useState({ loop: true, direction: "rtl" });

  // 2. تهيئة emblaApi بشكل آمن
  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  // 3. تعريف باقي خصائص Carousel بعد تهيئة emblaApi
  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi);
  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = usePrevNextButtons(emblaApi);

  // 4. استخدام useCallback لتجنب إعادة إنشاء الدالة مع كل تحديث
  const handleKeyDown = useCallback(
    (event) => {
      if (!emblaApi) return; // تحقق من وجود emblaApi

      if (event.key === "ArrowLeft") {
        emblaApi.scrollPrev();
      } else if (event.key === "ArrowRight") {
        emblaApi.scrollNext();
      }
    },
    [emblaApi]
  );

  // 5. إضافة مستمع مفاتيح الأسهم
  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [handleKeyDown]);

  // 6. تحميل البيانات مع تحسين معالجة الحياة
  useEffect(() => {
    let isMounted = true;

    const fetchServices = async () => {
      try {
        const data = await getHomeServices();

        if (!isMounted) return;

        setServices(data.data);
      } catch (err) {
        if (!isMounted) return;

        console.error("خطأ في تحميل الخدمات:", err);
        setError(err.message);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    // تأخير بسيط لضمان استقرار التطبيق
    setTimeout(fetchServices, 100);

    return () => {
      isMounted = false;
    };
  }, []);

  if (loading) {
    return (
    
      <section >

        <div className=" cw-full grid gap-[32px]">
          {/* Skelton Start*/}
          <h1 className="p-3">
            <DgaRectangleSkeleton size="md" type="1" width="short" />
          </h1>

          <h1>
            <DgaLineSkeleton size="sm" type="2" />
          </h1>

          <style>{`
  .sidebar-grid {
    display: grid;
    gap: 1rem;
    padding: 1rem;
 
    border-radius: 12px;
    grid-template-columns: repeat(4, 1fr);
    height:300px;
  }

  @media (max-width: 768px) {
    .sidebar-grid {
      grid-template-columns: 1fr;
    }
  }
`}</style>

          <div className="sidebar-grid">
            {[1, 2, 3, 4].map((col) => (
              <div
                key={col}
                style={{
                  background: "white",
                  padding: "1rem",
                  borderRadius: "8px",
                }}
              >
                <DgaCircleSkeleton type="1" width="80px" />
                <div style={{ marginTop: "1rem" }}>
                  {[1, 2, 3, 4, 5].map((item) => (
                    <DgaLineSkeleton
                      key={item}
                      type={item % 2 === 0 ? "1" : "2"}
                      size="sm"
                      style={{ marginBottom: "0.5rem" }}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
          {/* Skelton End*/}
        </div>
      </section>
     
    );
  }

  if (error && services.length === 0) {
    return (
      <section className="bg-[#F7FDF9]" id="services">
        <div className="flex justify-center items-center h-64">
          <p className="text-xl text-red-500">
            حدث خطأ أثناء تحميل الخدمات. يرجى المحاولة مرة أخرى لاحقًا.
          </p>
        </div>
      </section>
    );
  }

  return (
    <>

 
      <div className="bg-[#F7FDF9] !mb-[32px] fix-padding" style={{ backgroundImage: "url('/assets2/imges/Services Section.svg')", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center" }}>
 
        <div className="  c-ontent " id="services">

          <div className="cw-full ">


            <div className="grid gap-[24px]">

              <div className="flex justify-between">

                <div data-aos="fade-in" className="flex gap-[20px]  ">
                  <h1 className="display-sm-bold text-[#161616]" style={{ margin: "0px" }}  >
                    الخدمات
                  </h1>
                </div>


                <DgaButton
                  className="whitespace-nowrap"
                  label="عرض الكل"
                  variant="secondary-outline"
                  size="lg"
                  onClick={() => navigate("/electronic-services")}
                ></DgaButton>
              </div>
              <p data-aos="fade-in" data-aos-delay="100">
                توفر أمانة العاصمة المقدسة خدمات متنوعة للجهات الحكومية ولخدمات
                الأفراد
              </p>

            </div>


            <div className="  !mt-[32px]" data-aos="fade-in" data-aos-delay="200">


              <CarouselSlider data={services}  />

            </div>


          </div>


        </div>
      </div>

    </>
  );
}

export default ServicesSection;
